<template>
  <div>

    <div id="contasReceber" class="cardTable mb-1">
      <div v-if="!carregando && (totalContas === 0 || (contas && contas.length === 0))" class="empty-contas-container flex flex-col items-center justify-center p-8 bg-white rounded shadow-sm text-center">
        <div class="empty-icon-circle mb-4">
          <feather-icon icon="SearchIcon" svgClasses="w-12 h-12 text-primary" />
        </div>
        <h3 class="text-xl font-bold text-grey-darker mb-2">
          Nenhuma Conta a Receber Encontrada
        </h3>
        <p class="text-grey-dark max-w-lg mb-6 leading-relaxed" style="font-size: 14px;">
          Não foram encontradas contas a receber para os critérios informados.
          Tente filtrar por um período de datas maior (por exemplo, ampliando a data de vencimento, emissão ou quitação) ou redefinir os filtros de pesquisa.
        </p>
        <div class="flex items-center">
          <vs-button
            icon="search"
            type="line"
            size="small"
            @click="abrirFiltroModal()"
            color="#3da4fd"
          >
            <b style="font-size: 16px">Filtrar</b>
          </vs-button>
          <vs-button
            type="border"
            color="primary"
            icon-pack="feather"
            icon="icon-rotate-cw"
            class="ml-3"
            @click="limparFiltrosEBuscar()"
          >
            Redefinir Filtros
          </vs-button>
        </div>
      </div>
      <div v-show="carregando || totalContas > 0 || (contas && contas.length > 0)" class="contas-receber-container relative">
        <div id="tabelaContasReceber" class="vs-con-loading__container relative">
          <!-- Loading Centralizado na Tabela -->
          <transition name="fade-loading">
            <div v-if="carregando && contas && contas.length > 0" class="overlay-loading-tabela">
              <div class="loading-box-central">
                <div class="spinner-moderno"></div>
                <div class="loading-info-central">
                  <span class="loading-titulo-central">Carregando página {{ pagina }}...</span>
                  <span class="loading-subtitulo-central">Buscando registros</span>
                </div>
              </div>
            </div>
          </transition>

          <b-table-simple
          responsive
          small
          sticky-header="calc(100vh - 200px)"
          striped
          hover
          class="contas-tabela"
        >
          <b-thead>
            <b-tr>
              <b-th class="text-center" style="width: 5%">Nota</b-th>
              <b-th class="text-center" style="width: 5%">Emissão</b-th>
              <b-th class="text-center" style="width: 5%">Vencimento</b-th>
              <b-th class="text-center" style="width: 5%">Quitação</b-th>
              <b-th class="text-center" style="width: 10%">Cliente</b-th>
              <b-th class="text-center" style="width: 10%">ID Cliente</b-th>
              <b-th class="text-center" style="width: 10%">Empresa</b-th>
              <b-th class="text-center" style="width: 2%">Contrato</b-th>
              <b-th class="text-center" style="width: 8%">Valor</b-th>
              <b-th class="text-center" style="width: 8%">Juros</b-th>
              <b-th class="text-center" style="width: 8%">V. Pago</b-th>
              <b-th class="text-center" style="width: 12%">Plano Conta</b-th>
              <b-th class="text-center" style="width: 10%">Ações</b-th>
            </b-tr>
          </b-thead>

          <!-- SKELETON LOADING (apenas quando ainda não há dados na tabela para manter estabilidade visual) -->
          <b-tbody v-if="carregando && (!contas || contas.length === 0)">
            <b-tr v-for="n in 15" :key="'skel-' + n" class="skeleton-tr">
              <b-td class="text-center">
                <div class="skeleton-shimmer mx-auto" style="width: 42px; height: 16px;"></div>
              </b-td>
              <b-td class="text-center">
                <div class="skeleton-shimmer mx-auto" style="width: 68px; height: 16px;"></div>
              </b-td>
              <b-td class="text-center">
                <div class="skeleton-shimmer mx-auto" style="width: 68px; height: 16px;"></div>
              </b-td>
              <b-td class="text-center">
                <div class="skeleton-shimmer mx-auto" style="width: 68px; height: 16px;"></div>
              </b-td>
              <b-td class="text-left">
                <div class="skeleton-shimmer" :style="{ width: (n % 2 === 0 ? '85%' : '65%'), height: '16px' }"></div>
              </b-td>
              <b-td class="text-center">
                <div class="skeleton-shimmer mx-auto" style="width: 48px; height: 16px;"></div>
              </b-td>
              <b-td class="text-left">
                <div class="skeleton-shimmer" :style="{ width: (n % 3 === 0 ? '90%' : '70%'), height: '16px' }"></div>
              </b-td>
              <b-td class="text-center">
                <div class="skeleton-shimmer mx-auto" style="width: 32px; height: 16px;"></div>
              </b-td>
              <b-td class="text-center">
                <div class="skeleton-shimmer mx-auto" style="width: 62px; height: 16px;"></div>
              </b-td>
              <b-td class="text-center">
                <div class="skeleton-shimmer mx-auto" style="width: 48px; height: 16px;"></div>
              </b-td>
              <b-td class="text-center">
                <div class="skeleton-shimmer mx-auto" style="width: 62px; height: 16px;"></div>
              </b-td>
              <b-td class="text-left">
                <div class="skeleton-shimmer" :style="{ width: (n % 2 === 0 ? '75%' : '88%'), height: '16px' }"></div>
              </b-td>
              <b-td class="text-center">
                <div class="skeleton-shimmer mx-auto" style="width: 72px; height: 22px; border-radius: 6px;"></div>
              </b-td>
            </b-tr>
          </b-tbody>

          <!-- DADOS REAIS (mantém visível com suave opacidade durante troca de página ou busca) -->
          <b-tbody
            v-else
            :style="{
              opacity: carregando ? 0.75 : 1,
              pointerEvents: carregando ? 'none' : 'auto',
              transition: 'opacity 0.2s ease'
            }"
          >
            <b-tr
                v-for="(conta, index) in contas"
                :key="index"
                :style="
                  conta.negativado > 0
                  ? 'color:red ;background-color: #e1bee7 !important'
                  : conta.vencido > 0
                  ? 'color:red ;background-color: #fce3e3 !important'
                  : conta.id_status == 4
                  ? 'color: green;background-color:#e8fce8 !important;'
                  : conta.id_status == 3
                  ? 'color:#00BBA2;background-color: #dff2f0 !important'
                  : ''
              "
            >

              <b-td class="text-center font-bold" style="font-size: 12px">
                {{
                  conta.nota > 0
                      ? conta.nota + (conta.parcela ? "." + conta.parcela : "")
                      : "..."
                }}
              </b-td>
              <b-td class="text-center" style="font-size: 12px">
                {{ conta.emissao ? conta.emissao : "..." }}
              </b-td>
              <b-td class="text-center" style="font-size: 12px">
                {{ conta.vencimento ? conta.vencimento : "..." }}
              </b-td>
              <b-td class="text-center" style="font-size: 12px">
                {{ conta.pagamento ? conta.pagamento : "..." }}
              </b-td>
              <b-td>
                <vs-button
                    class="py-0 px-0 my-0 pr-1"
                    color="dark"
                    size="small"
                    type="line"
                    @click="
                    renderComponent('VisualizarCliente', conta.id_cliente)
                  "
                >
                  <span class="nome-cliente-small">
                    {{ conta.cliente ? conta.cliente : "..." }}
                  </span>
                </vs-button>
              </b-td>
              <b-td class="text-center" style="font-size: 12px">
                {{ conta.id_cliente ? conta.id_cliente : "..." }}
              </b-td>
              <b-td class="text-center" style="font-size: 12px">
                {{ conta.empresa ? conta.empresa : "..." }}
              </b-td>
              <b-td class="text-center">
                <a
                    :href="'contrato?id=' + conta.id_contrato"
                    style="color: darkblue; cursor: pointer; font-size: 10px"
                    target="_blank"
                >
                  <b>{{ conta.id_contrato }}</b>
                </a>
              </b-td>
              <b-td class="text-center font-bold" style="font-size: 12px">
                {{ $currency(conta.valor) }}
              </b-td>
              <b-td class="text-center font-bold" style="font-size: 12px">
                {{ $currency(conta.juros) }}
              </b-td>
              <b-td class="text-center" style="font-size: 12px">
                <div
                    style="
                    font-size: 12px;
                    cursor: pointer;
                    text-decoration: underline;
                  "
                    @click="
                    conta.valor_pago > 0
                      ? renderComponent('pagamentoParcial', conta)
                      : 1
                  "
                >
                  <b>
                    {{
                      $currency(
                          parseFloat(conta.valor_pago) +
                          parseFloat(conta.juros || 0)
                      )
                    }}
                  </b>
                </div>
              </b-td>
              <b-td class="text-center" style="font-size: 12px">
                {{ conta.plano_contas ? conta.plano_contas : "..." }}
              </b-td>
              <b-td style="font-size: 12px">
                <div class="w-full">
                  <vs-row
                      vs-align="center"
                      vs-justify="center"
                      vs-type="flex"
                      vs-w="12"
                  >
                    <vs-col
                        :vs-w="conta.vencido || conta.negativado ? 3 : 4"
                        vs-align="center"
                        vs-justify="center"
                        vs-type="flex"
                    >
                      <vs-button
                          :disabled="
                          !$atividades.permissoes.includes(5)
                        "
                          color="primary"
                          icon="edit"
                          size="small"
                          @click="renderComponent('Editar', conta)"
                      />
                    </vs-col>
                    <vs-col
                        :vs-w="conta.vencido || conta.negativado ? 3 : 4"
                        vs-align="center"
                        vs-justify="center"
                        vs-type="flex"
                    >
                      <vs-button
                          :color="conta.id_status == 4 ? '#128712' : 'success'"
                          :disabled="
                          !$atividades.permissoes.includes(5) ||
                            conta.id_status == 4 ||
                            conta.id_status == 5
                        "
                          icon="done"
                          size="small"
                          @click="renderComponent('Quitar', conta)"
                      />
                    </vs-col>
                    <vs-col
                        :vs-w="conta.vencido || conta.negativado ? 3 : 4"
                        vs-align="center"
                        vs-justify="center"
                        vs-type="flex"
                    >
                      <el-popconfirm
                          :confirmButtonText="
                          conta.id_status > 2 ? 'Desquitar' : 'Excluir conta'
                        "
                          :icon="
                          conta.id_status > 2
                            ? 'el-icon-circle-close'
                            : 'el-icon-delete'
                        "
                          :title="
                          conta.id_status > 2
                            ? conta.id_status == 3
                              ? 'Cancelar quitação parcial desta conta?'
                              : 'Cancelar quitação desta conta?'
                            : 'Deseja excluir esta conta?'
                        "
                          cancelButtonText="Cancelar"
                          iconColor="red"
                          @confirm="
                          conta.id_status > 2
                            ? quitacaoDelet(conta)
                            : deletar(conta)
                        "
                      >
                        <vs-button
                            slot="reference"
                            :disabled="
                            !$atividades.permissoes.includes(6) ||
                              buttonDisabled ||
                              conta.id_status > 4
                          "
                            color="danger"
                            icon="close"
                            size="small"
                        />
                      </el-popconfirm>
                    </vs-col>
                    <vs-col
                        v-if="conta.vencido && !conta.negativado"
                        vs-align="center"
                        vs-justify="center"
                        vs-type="flex"
                        vs-w="3"
                    >
                      <vs-button
                          :disabled="!$atividades.permissoes.includes(5)"
                          color="#311b92"
                          icon="info"
                          size="small"
                          @click="renderComponent('Negativar', conta)"
                      />
                    </vs-col>
                    <vs-col
                        v-else-if="conta.negativado"
                        vs-align="center"
                        vs-justify="center"
                        vs-type="flex"
                        vs-w="3"
                    >
                      <vx-tooltip :text="conta.motivo" color="#311b92">
                        <vs-button
                            :disabled="!$atividades.permissoes.includes(5)"
                            color="#311b92"
                            icon="reply"
                            size="small"
                            @click="confirmarDesnegativacao(conta)"
                        />
                      </vx-tooltip>
                    </vs-col>
                  </vs-row>
                </div>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        </div>

        <div class="flex flex-wrap items-center justify-between px-3 py-1 bg-white rounded-b border border-t-0 border-solid border-grey-light shadow-sm relative" style="min-height: 40px; z-index: 10;">
          <div class="text-sm text-grey-dark font-medium flex items-center">
            <span>
              Exibindo página <b>{{ pagina || (paginacao && paginacao.pagina) || 1 }}</b> de <b>{{ (paginacao && paginacao.totalPaginas) || 1 }}</b> (Total: <b>{{ totalContasFormatado }}</b> contas)
            </span>
            <span v-if="carregando" class="ml-3 inline-flex items-center text-primary text-xs font-semibold">
              <feather-icon icon="LoaderIcon" svgClasses="w-3 h-3 mr-1 rotacionar-spinner text-primary" />
              Carregando...
            </span>
          </div>
          <div class="flex items-center">
            <span class="text-xs text-grey-dark mr-2 font-medium">Itens por página:</span>
            <el-select
              v-model="itensPorPagina"
              size="mini"
              style="width: 85px;"
              class="mr-4"
              :popper-append-to-body="true"
              popper-class="popper-itens-paginacao"
              @change="mudarItensPorPagina"
            >
              <el-option :value="50" label="50"></el-option>
              <el-option :value="100" label="100"></el-option>
              <el-option :value="200" label="200"></el-option>
            </el-select>
            <vs-pagination
              :total="Math.max(pagina, (paginacao && paginacao.totalPaginas) || 1)"
              :value="pagina"
              @input="navegarPagina"
            />
          </div>
        </div>
      </div>
    </div>
    <vx-card card-background="dark" no-shadow class="barra-rodape-escuro">
      <div class="rodape-flex-container">
        <!-- ESQUERDA: Botão Voltar -->
        <div class="rodape-col-voltar">
          <vs-button
              color="#fff"
              icon="icon-arrow-left"
              icon-pack="feather"
              line-origin="left"
              size="small"
              type="line"
              @click="voltar()"
          >
            <span style="font-size: 14px">Voltar</span>
          </vs-button>
        </div>

        <!-- CENTRO: Totalizadores com layout fluido e estável -->
        <div class="rodape-col-valores">
          <template v-if="carregando && totalContas === 0">
            <div class="total-pill">
              <span class="total-label">Contas:</span>
              <div class="skeleton-shimmer-dark ml-2 inline-block" style="width: 45px; height: 16px;"></div>
            </div>
            <div class="total-pill">
              <span class="total-label">Valor Total:</span>
              <div class="skeleton-shimmer-dark ml-2 inline-block" style="width: 65px; height: 16px;"></div>
            </div>
            <div class="total-pill">
              <span class="total-label">Juros Total:</span>
              <div class="skeleton-shimmer-dark ml-2 inline-block" style="width: 50px; height: 16px;"></div>
            </div>
            <div class="total-pill">
              <span class="total-label">Valor Recebido:</span>
              <div class="skeleton-shimmer-dark ml-2 inline-block" style="width: 65px; height: 16px;"></div>
            </div>
            <div class="total-pill">
              <span class="total-label">Recebido + Juros:</span>
              <div class="skeleton-shimmer-dark ml-2 inline-block" style="width: 65px; height: 16px;"></div>
            </div>
          </template>
          <template v-else>
            <div class="total-pill">
              <span class="total-label">Contas:</span>
              <strong class="total-val">{{ totalContasFormatado }}</strong>
            </div>
            <div class="total-pill">
              <span class="total-label">Valor Total:</span>
              <strong class="total-val">{{ $currency(total) }}</strong>
            </div>
            <div class="total-pill">
              <span class="total-label">Juros Total:</span>
              <strong class="total-val">{{ $currency(totalJuros) }}</strong>
            </div>
            <div class="total-pill">
              <span class="total-label">Valor Recebido:</span>
              <strong class="total-val">{{ $currency(totalRecebido) }}</strong>
            </div>
            <div class="total-pill">
              <span class="total-label">Recebido + Juros:</span>
              <strong class="total-val">{{ $currency(totalRecebidoJuros) }}</strong>
            </div>
          </template>
        </div>

        <!-- DIREITA: Ações sem sobreposição -->
        <div class="rodape-col-acoes">
          <ModalCadastroFornecedor @update="getFornecedores"/>
          <Cadastrar @update="getContasReceber"/>
          <Filtro ref="filtroModal" :filtro-inicial="filtro" @filtro="Filtrar"/>
          <vs-button
              v-if="temFiltrosAtivos"
              color="#ea5455"
              icon="clear"
              size="small"
              type="line"
              @click="limparFiltrosEBuscar()"
              title="Limpar todos os filtros aplicados"
          >
            <b style="font-size: 14px">Limpar Filtro</b>
          </vs-button>
          <vs-button
              v-if="$atividades.podeExportar()"
              color="#FFCA00"
              icon="get_app"
              size="small"
              type="line"
              @click="exportToExcel()"
              title="Exportar planilha Excel via streaming com progresso"
          >
            <b style="font-size: 14px">Excel</b>
          </vs-button>
        </div>
      </div>
    </vx-card>

    <component
        v-bind:is="buttonComponent"
        :key="reRenderButtonComponent"
        :conta="selectedItem"
        :id_cliente="selectedItem"
        @update="getContasReceber"
    />

    <!-- MODAL DE PROGRESSO DE EXPORTAÇÃO EXCEL EM STREAMING -->
    <vs-popup
      :active.sync="modalExportacaoActive"
      title="Exportação de Contas a Receber"
      class="modal-exportacao-excel"
      :button-close-hidden="exportando"
    >
      <div class="p-4 text-center">
        <!-- Ícone de Status -->
        <div class="mb-4 flex justify-center items-center" style="min-height: 60px;">
          <vs-icon
            v-if="exportando"
            icon="sync"
            size="52px"
            color="#00BBA2"
            class="rotacionar-spinner"
          />
          <vs-icon
            v-else-if="exportacaoSucesso"
            icon="check_circle"
            size="52px"
            color="#28c76f"
          />
          <vs-icon
            v-else
            icon="error"
            size="52px"
            color="#ea5455"
          />
        </div>

        <h4 class="font-bold text-lg mb-2" style="color: #1e293b;">
          {{ tituloStatusExportacao }}
        </h4>
        <p class="text-sm text-gray-600 mb-6 px-4">
          {{ mensagemStatusExportacao }}
        </p>

        <!-- Barra de Progresso -->
        <div class="mb-6 px-2">
          <div class="flex justify-between items-center mb-1 text-sm font-semibold">
            <span style="color: #475569;">Progresso da Transmissão</span>
            <span style="color: #00BBA2;" class="font-bold">{{ progressoPercent }}%</span>
          </div>
          <div class="w-full bg-gray-200 rounded-full h-3 overflow-hidden shadow-inner" style="background-color: #e2e8f0; border-radius: 9999px; height: 12px;">
            <div
              class="h-full rounded-full transition-all duration-300 ease-out"
              :style="{
                width: progressoPercent + '%',
                backgroundColor: exportacaoSucesso ? '#28c76f' : (exportando ? '#00BBA2' : '#ea5455')
              }"
            ></div>
          </div>
        </div>

        <!-- Indicadores / Estatísticas da Transmissão em Stream -->
        <div class="flex justify-around items-center mb-6 p-3 rounded-lg" style="background-color: #f8fafc; border: 1px solid #e2e8f0;">
          <div class="flex flex-col items-center">
            <span class="text-xs uppercase font-semibold" style="color: #64748b;">Total no Filtro</span>
            <span class="text-base font-bold" style="color: #1e293b;">{{ totalContasFormatado }} registros</span>
          </div>
          <div class="flex flex-col items-center">
            <span class="text-xs uppercase font-semibold" style="color: #64748b;">Dados Transferidos</span>
            <span class="text-base font-bold" style="color: #00BBA2;">{{ tamanhoBaixadoTexto }}</span>
          </div>
        </div>

        <!-- Ações: Cancelar ou Fechar -->
        <div class="flex justify-center mt-2">
          <vs-button
            v-if="exportando"
            color="danger"
            type="flat"
            icon="cancel"
            @click="cancelarExportacao"
          >
            Cancelar
          </vs-button>
          <vs-button
            v-else
            color="#1B2A47"
            type="filled"
            icon="done"
            @click="modalExportacaoActive = false"
          >
            Fechar
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import axios from "axios";
import components from "@/components/default/exports.js";
import VisualizarCliente from "./../../../cliente/visualizarSemBotao.vue";
import Filtro from "./components/filtro";
import Cadastrar from "./components/cadastrar";
import Quitar from "./components/quitar";
import pagamentoParcial from "./components/pagamentoParcial";
import Editar from "./components/editar";
import Negativar from "./components/negativar";
import ModalCadastroFornecedor from '../../../fornecedor/cadastro.vue'

function parseFiltrosDaQuery(query, dataHojePadrao) {
  const q = query || {};
  const pag = parseInt(q.pagina, 10);
  const pagina = (pag && pag > 0) ? pag : 1;

  const itens = parseInt(q.itensPorPagina, 10);
  const itensPorPagina = ([50, 100, 200].indexOf(itens) !== -1) ? itens : 50;

  const novoFiltro = {};
  let temFiltroNaUrl = false;

  // Cliente (suporta texto, id numérico e query.id_cliente)
  if (q.cliente !== undefined && q.cliente !== null && q.cliente !== '') {
    temFiltroNaUrl = true;
    novoFiltro.cliente = q.cliente;
    if (Number(q.cliente) > 0 && String(Number(q.cliente)) === String(q.cliente)) {
      novoFiltro.id_cliente = Number(q.cliente);
    }
  }
  if (q.id_cliente && Number(q.id_cliente) > 0) {
    temFiltroNaUrl = true;
    novoFiltro.id_cliente = Number(q.id_cliente);
    if (!novoFiltro.cliente) {
      novoFiltro.cliente = String(q.id_cliente);
    }
  }

  // Contrato
  if (q.contrato && Number(q.contrato) > 0) {
    temFiltroNaUrl = true;
    novoFiltro.id_contrato = Number(q.contrato);
  }
  if (q.id_contrato && Number(q.id_contrato) > 0) {
    temFiltroNaUrl = true;
    novoFiltro.id_contrato = Number(q.id_contrato);
  }

  // NF
  if (q.nf !== undefined && q.nf !== null && q.nf !== '') {
    temFiltroNaUrl = true;
    novoFiltro.nf = q.nf;
  }

  // Tipo de Pessoa (Number para casar com el-select)
  if (q.tipo_pessoa !== undefined && q.tipo_pessoa !== null && q.tipo_pessoa !== '') {
    temFiltroNaUrl = true;
    novoFiltro.tipo_pessoa = Number(q.tipo_pessoa);
  }

  // Forma de Pagamento
  const idForma = q.id_forma_pagamento || q.forma_pagamento;
  if (idForma !== undefined && idForma !== null && idForma !== '') {
    temFiltroNaUrl = true;
    novoFiltro.id_forma_pagamento = Number(idForma);
  }

  // Empresa
  const idEmpresa = q.id_empresa || q.empresa;
  if (idEmpresa !== undefined && idEmpresa !== null && idEmpresa !== '') {
    temFiltroNaUrl = true;
    novoFiltro.id_empresa = Number(idEmpresa);
  }

  // Portador
  const idPortador = q.id_portador || q.portador;
  if (idPortador !== undefined && idPortador !== null && idPortador !== '') {
    temFiltroNaUrl = true;
    novoFiltro.id_portador = Number(idPortador);
  }

  // Plano de Conta
  const idPlano = q.id_plano_conta || q.plano_conta;
  if (idPlano !== undefined && idPlano !== null && idPlano !== '') {
    temFiltroNaUrl = true;
    novoFiltro.id_plano_conta = Number(idPlano);
  }

  // Status
  const idStatus = q.id_status || q.status;
  if (idStatus !== undefined && idStatus !== null && idStatus !== '') {
    temFiltroNaUrl = true;
    novoFiltro.id_status = Number(idStatus);
  }

  // Vendedor
  const idVendedor = q.id_vendedor || q.vendedor;
  if (idVendedor !== undefined && idVendedor !== null && idVendedor !== '') {
    temFiltroNaUrl = true;
    novoFiltro.id_vendedor = Number(idVendedor);
  }

  // Parcelas em Atraso
  if (q.parcelasEmAtraso !== undefined && q.parcelasEmAtraso !== null && q.parcelasEmAtraso !== '') {
    temFiltroNaUrl = true;
    novoFiltro.parcelasEmAtraso = q.parcelasEmAtraso;
  }

  // Suspenso e Negativado
  if (q.suspenso === 'true' || q.suspenso === true || q.suspenso === '1') {
    temFiltroNaUrl = true;
    novoFiltro.suspenso = true;
  }
  if (q.negativado === 'true' || q.negativado === true || q.negativado === '1') {
    temFiltroNaUrl = true;
    novoFiltro.negativado = true;
  }

  // Valores
  if (q.valorDe !== undefined && q.valorDe !== null && q.valorDe !== '') {
    temFiltroNaUrl = true;
    novoFiltro.valorDe = q.valorDe;
  }
  if (q.valorAte !== undefined && q.valorAte !== null && q.valorAte !== '') {
    temFiltroNaUrl = true;
    novoFiltro.valorAte = q.valorAte;
  }

  // Quitação / Pagamento (com aliases)
  const pagDe = q.pagamentoDe || q.quitacaoDe;
  const pagAte = q.pagamentoAte || q.quitacaoAte;
  if (pagDe) {
    temFiltroNaUrl = true;
    novoFiltro.pagamentoDe = pagDe;
  }
  if (pagAte) {
    temFiltroNaUrl = true;
    novoFiltro.pagamentoAte = pagAte;
  }

  // Vencimento (com aliases)
  const vencDe = q.dataDe || q.vencimentoDe;
  const vencAte = q.dataAte || q.vencimentoAte;
  if (vencDe) {
    temFiltroNaUrl = true;
    novoFiltro.dataDe = vencDe;
  }
  if (vencAte) {
    temFiltroNaUrl = true;
    novoFiltro.dataAte = vencAte;
  }

  // Emissão
  if (q.emissaoDe) {
    temFiltroNaUrl = true;
    novoFiltro.emissaoDe = q.emissaoDe;
  }
  if (q.emissaoAte) {
    temFiltroNaUrl = true;
    novoFiltro.emissaoAte = q.emissaoAte;
  }

  // Observação (com alias)
  const obs = q.obs || q.observacao;
  if (obs !== undefined && obs !== null && obs !== '') {
    temFiltroNaUrl = true;
    novoFiltro.obs = obs;
  }

  // Se não há nenhum filtro na URL, aplica dataHoje padrão
  if (!temFiltroNaUrl && dataHojePadrao) {
    novoFiltro.dataHoje = dataHojePadrao;
  }

  return {
    pagina: pagina,
    itensPorPagina: itensPorPagina,
    filtro: novoFiltro
  };
}

export default {
  data() {
    const q = (this.$route && this.$route.query) || {};
    const hoje = (this.$formartData && this.$formartData.dataFiltro) ? this.$formartData.dataFiltro() : '';
    const estado = parseFiltrosDaQuery(q, hoje);

    return {
      settings: {
        maxScrollbarLength: 160,
        wheelSpeed: 9.5,
        height: 1000
      },
      filtro: estado.filtro,
      contas: [],
      pagina: estado.pagina,
      itensPorPagina: estado.itensPorPagina,
      totalContas: 0,
      paginacao: {
        total: 0,
        pagina: estado.pagina,
        itensPorPagina: estado.itensPorPagina,
        totalPaginas: estado.pagina
      },
      totalRecebido: 0,
      totalRecebidoJuros: 0,
      total: 0,
      totalJuros: 0,
      buttonDisabled: false,
      buttonComponent: "",
      reRenderButtonComponent: 0,
      selectedItem: {},
      searchCancelSource: null,
      requisicaoAtualId: 0,
      // Exportação Streaming Excel
      modalExportacaoActive: false,
      exportando: false,
      exportacaoSucesso: false,
      progressoPercent: 0,
      tamanhoBaixadoTexto: "0.00 MB",
      tituloStatusExportacao: "",
      mensagemStatusExportacao: "",
      exportAbortController: null,
      carregando: false
    };
  },
  computed: {
    totalContasFormatado() {
      const count = this.totalContas || (this.paginacao && this.paginacao.total) || 0;
      return Number(count).toLocaleString('pt-BR');
    },
    temFiltrosAtivos() {
      if (!this.filtro) return false;
      const chaves = Object.keys(this.filtro);
      for (let i = 0; i < chaves.length; i++) {
        const k = chaves[i];
        if (k === 'dataHoje') continue;
        const val = this.filtro[k];
        if (val !== undefined && val !== null && val !== '') {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    async getContasReceber() {
      // Cancela requisição anterior em trânsito se houver
      if (this.searchCancelSource) {
        this.searchCancelSource.cancel('Nova busca iniciada');
      }
      this.searchCancelSource = axios.CancelToken ? axios.CancelToken.source() : null;

      // Controle sequencial de requisição para descartar respostas obsoletas
      this.requisicaoAtualId = (this.requisicaoAtualId || 0) + 1;
      const reqId = this.requisicaoAtualId;

      this.carregando = true;
      try {
        const payload = {
          ...this.filtro,
          pagina: this.pagina,
          itensPorPagina: this.itensPorPagina
        };

        const config = {};
        if (this.searchCancelSource) {
          config.cancelToken = this.searchCancelSource.token;
        }

        const res = await this.$http.post(`getContasReceber`, payload, config);

        // Se uma requisição mais recente foi disparada, descarta este resultado
        if (reqId !== this.requisicaoAtualId) {
          return;
        }

        if (res && res.contas && res.paginacao) {
          this.contas = res.contas;
          this.paginacao = res.paginacao;
          this.totalContas = res.paginacao.total;
          if (res.totalizadores) {
            this.total = Number(res.totalizadores.total) || 0;
            this.totalRecebido = Number(res.totalizadores.totalRecebido) || 0;
            this.totalJuros = Number(res.totalizadores.totalJuros) || 0;
            this.totalRecebidoJuros = Number(res.totalizadores.totalRecebidoJuros) || 0;
          }
        } else if (Array.isArray(res)) {
          this.totalContas = res.length;
          this.total = res.reduce((prev, cur) => prev + (Number(cur.valor) || 0), 0);
          this.totalRecebido = res.reduce((prev, cur) => prev + (Number(cur.valor_pago) || 0), 0);
          this.totalJuros = res.reduce((prev, cur) => prev + (Number(cur.juros) || 0), 0);
          this.totalRecebidoJuros = this.totalRecebido + this.totalJuros;
          this.paginacao = {
            total: res.length,
            pagina: this.pagina,
            itensPorPagina: this.itensPorPagina,
            totalPaginas: Math.ceil(res.length / this.itensPorPagina) || 1
          };
          const start = (this.pagina - 1) * this.itensPorPagina;
          this.contas = res.slice(start, start + this.itensPorPagina);
        } else {
          this.contas = [];
          this.totalContas = 0;
          this.total = 0;
          this.totalRecebido = 0;
          this.totalJuros = 0;
          this.totalRecebidoJuros = 0;
          this.paginacao = {
            total: 0,
            pagina: 1,
            itensPorPagina: this.itensPorPagina,
            totalPaginas: 1
          };
        }
      } catch (err) {
        if (axios.isCancel && axios.isCancel(err)) {
          return;
        }
        if (reqId !== this.requisicaoAtualId) {
          return;
        }
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        if (reqId === this.requisicaoAtualId) {
          this.carregando = false;
          try {
            await this.$vs.loading.close("#tabelaContasReceber > .con-vs-loading");
          } catch (closeErr) {}
        }
      }
    },
    navegarPagina(val) {
      const novaPagina = Math.max(1, parseInt(val, 10) || 1);
      if (novaPagina === this.pagina) {
        return;
      }
      this.pagina = novaPagina;
      if (this.paginacao) {
        this.paginacao.pagina = novaPagina;
        if (this.paginacao.totalPaginas < novaPagina) {
          this.paginacao.totalPaginas = novaPagina;
        }
      }
      this.$nextTick(() => {
        const tableContainer = this.$el.querySelector('.b-table-sticky-header');
        if (tableContainer) {
          tableContainer.scrollTop = 0;
        }
      });
      const query = this.gerarQueryDeFiltro(this.pagina, this.itensPorPagina, this.filtro);
      this.sincronizarUrl(query);
      this.getContasReceber();
    },
    mudarItensPorPagina() {
      this.pagina = 1;
      if (this.paginacao) {
        this.paginacao.pagina = 1;
      }
      const query = this.gerarQueryDeFiltro(1, this.itensPorPagina, this.filtro);
      this.sincronizarUrl(query);
      this.getContasReceber();
    },
    cancelarExportacao() {
      if (this.exportAbortController) {
        this.exportAbortController.abort();
      }
      this.exportando = false;
      this.tituloStatusExportacao = "Exportação Cancelada";
      this.mensagemStatusExportacao = "A transmissão dos dados via stream foi interrompida pelo usuário.";
    },
    async exportToExcel() {
      if (!this.$atividades.podeExportar()) return;

      this.modalExportacaoActive = true;
      this.exportando = true;
      this.exportacaoSucesso = false;
      this.progressoPercent = 0;
      this.tamanhoBaixadoTexto = "0.00 MB";
      this.tituloStatusExportacao = "Transmitindo em Stream...";
      this.mensagemStatusExportacao = "O servidor está gerando o arquivo Excel e enviando dados em streaming contínuo diretamente do banco de dados.";

      // AbortController para cancelamento seguro sem vazamento de conexão
      this.exportAbortController = window.AbortController ? new AbortController() : null;
      try {
        const self = this;
        const totalRegistrosFiltro = this.totalContas || (this.paginacao && this.paginacao.total) || 100;
        const totalEstimadoBytes = Math.max(50000, totalRegistrosFiltro * 180);

        const config = {
          responseType: "arraybuffer",
          signal: this.exportAbortController ? this.exportAbortController.signal : undefined,
          onDownloadProgress: function(progressEvent) {
            const loaded = progressEvent.loaded || 0;
            self.tamanhoBaixadoTexto = (loaded / (1024 * 1024)).toFixed(2) + " MB";

            let percent = 0;
            if (progressEvent.total || progressEvent.lengthComputable) {
              const total = progressEvent.total || progressEvent.lengthComputable;
              percent = Math.round((loaded * 100) / total);
            } else {
              percent = Math.round((loaded * 100) / totalEstimadoBytes);
            }
            self.progressoPercent = Math.min(95, Math.max(5, percent));
          }
        };

        const res = await this.$http.post(
          "contas-receber/exportar-excel-stream",
          { ...this.filtro },
          config
        );

        this.progressoPercent = 100;
        this.exportando = false;
        this.exportacaoSucesso = true;
        this.tituloStatusExportacao = "Exportação Concluída!";
        this.mensagemStatusExportacao = "Arquivo Excel gerado com sucesso via stream. O download foi iniciado no seu navegador.";

        const rawData = res;
        if (rawData && rawData.byteLength && rawData.byteLength < 500) {
          try {
            const text = new TextDecoder().decode(rawData);
            const parsed = JSON.parse(text);
            if (parsed.message) {
              throw new Error(parsed.message);
            }
          } catch (parseErr) {
            if (parseErr.message && parseErr.message.indexOf("Unexpected") === -1) {
              throw parseErr;
            }
          }
        }

        const blob = new Blob([rawData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        const agora = new Date();
        const dia = String(agora.getDate()).padStart(2, "0");
        const mes = String(agora.getMonth() + 1).padStart(2, "0");
        const ano = agora.getFullYear();
        link.download = "contas-a-receber-" + dia + "-" + mes + "-" + ano + ".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);

        this.$vs.notify({
          title: "Download Concluído",
          text: "Planilha de Contas a Receber exportada com sucesso!",
          color: "success"
        });
      } catch (err) {
        if (err.name === "AbortError" || (err.message && err.message.indexOf("canceled") !== -1)) {
          return;
        }

        this.exportando = false;
        this.exportacaoSucesso = false;
        this.tituloStatusExportacao = "Falha na Exportação";
        const msg = (err.response && err.response.data && err.response.data.message)
          ? err.response.data.message
          : (err.message || "Erro ao gerar arquivo Excel em streaming.");
        this.mensagemStatusExportacao = msg;

        this.$vs.notify({
          title: "Erro na Exportação",
          text: msg,
          color: "danger"
        });
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
          filterVal.map(j => {
            return v[j];
          })
      );
    },
    async voltar() {
      this.$router.push("/financeiro");
    },
    abrirFiltroModal() {
      if (this.$refs.filtroModal && this.$refs.filtroModal.openModal) {
        this.$refs.filtroModal.openModal();
      }
    },
    async Filtrar(filtro) {
      this.pagina = 1;
      if (this.paginacao) {
        this.paginacao.pagina = 1;
      }
      const f = filtro ? { ...filtro } : {};
      const temFiltro = Object.keys(f).some(function (k) {
        var v = f[k];
        return v !== undefined && v !== null && v !== '';
      });
      const novoFiltro = temFiltro ? f : {};
      if (!temFiltro) {
        const hoje = (this.$formartData && this.$formartData.dataFiltro) ? this.$formartData.dataFiltro() : '';
        if (hoje) {
          novoFiltro.dataHoje = hoje;
        }
      }
      this.filtro = novoFiltro;
      const query = this.gerarQueryDeFiltro(1, this.itensPorPagina, temFiltro ? novoFiltro : {});
      this.sincronizarUrl(query);
      this.getContasReceber();
    },
    limparFiltrosEBuscar() {
      this.pagina = 1;
      if (this.paginacao) {
        this.paginacao.pagina = 1;
      }
      this.filtro = {
        dataHoje: (this.$formartData && this.$formartData.dataFiltro) ? this.$formartData.dataFiltro() : ''
      };
      const query = this.gerarQueryDeFiltro(1, this.itensPorPagina, {});
      this.sincronizarUrl(query);
      this.getContasReceber();
    },
    inicializarFiltrosDaUrl() {
      const query = (this.$route && this.$route.query) || {};
      const hoje = (this.$formartData && this.$formartData.dataFiltro) ? this.$formartData.dataFiltro() : '';
      const estado = parseFiltrosDaQuery(query, hoje);

      this.pagina = estado.pagina;
      this.itensPorPagina = estado.itensPorPagina;
      this.filtro = estado.filtro;

      if (!this.paginacao) {
        this.paginacao = {
          total: 0,
          pagina: estado.pagina,
          itensPorPagina: estado.itensPorPagina,
          totalPaginas: estado.pagina
        };
      } else {
        this.paginacao.pagina = estado.pagina;
        this.paginacao.itensPorPagina = estado.itensPorPagina;
        if (this.paginacao.totalPaginas < estado.pagina) {
          this.paginacao.totalPaginas = estado.pagina;
        }
      }
    },
    gerarQueryDeFiltro(pagina, itensPorPagina, filtro) {
      const query = {};

      query.pagina = String(pagina || 1);
      query.itensPorPagina = String(itensPorPagina || 50);

      if (!filtro) return query;

      if (filtro.cliente) query.cliente = String(filtro.cliente);
      if (filtro.id_cliente) query.id_cliente = String(filtro.id_cliente);
      if (filtro.id_contrato) query.id_contrato = String(filtro.id_contrato);
      if (filtro.nf) query.nf = String(filtro.nf);
      if (filtro.obs) query.obs = String(filtro.obs);

      if (filtro.tipo_pessoa !== undefined && filtro.tipo_pessoa !== null && filtro.tipo_pessoa !== '') {
        query.tipo_pessoa = String(filtro.tipo_pessoa);
      }
      if (filtro.id_forma_pagamento) query.id_forma_pagamento = String(filtro.id_forma_pagamento);
      if (filtro.id_empresa) query.id_empresa = String(filtro.id_empresa);
      if (filtro.id_portador) query.id_portador = String(filtro.id_portador);
      if (filtro.id_plano_conta) query.id_plano_conta = String(filtro.id_plano_conta);
      if (filtro.id_status) query.id_status = String(filtro.id_status);
      if (filtro.id_vendedor) query.id_vendedor = String(filtro.id_vendedor);

      if (filtro.parcelasEmAtraso !== undefined && filtro.parcelasEmAtraso !== null && filtro.parcelasEmAtraso !== '') {
        query.parcelasEmAtraso = String(filtro.parcelasEmAtraso);
      }

      if (filtro.suspenso === true || filtro.suspenso === 'true' || filtro.suspenso === 1) {
        query.suspenso = 'true';
      }
      if (filtro.negativado === true || filtro.negativado === 'true' || filtro.negativado === 1) {
        query.negativado = 'true';
      }

      if (filtro.valorDe !== undefined && filtro.valorDe !== null && filtro.valorDe !== '') {
        query.valorDe = String(filtro.valorDe);
      }
      if (filtro.valorAte !== undefined && filtro.valorAte !== null && filtro.valorAte !== '') {
        query.valorAte = String(filtro.valorAte);
      }

      if (filtro.pagamentoDe) query.pagamentoDe = String(filtro.pagamentoDe);
      if (filtro.pagamentoAte) query.pagamentoAte = String(filtro.pagamentoAte);
      if (filtro.dataDe) query.dataDe = String(filtro.dataDe);
      if (filtro.dataAte) query.dataAte = String(filtro.dataAte);
      if (filtro.emissaoDe) query.emissaoDe = String(filtro.emissaoDe);
      if (filtro.emissaoAte) query.emissaoAte = String(filtro.emissaoAte);

      return query;
    },
    sincronizarUrl(query) {
      if (!query) {
        query = this.gerarQueryDeFiltro(this.pagina, this.itensPorPagina, this.filtro);
      }
      const queryAtual = this.$route.query || {};
      const chavesAtuais = Object.keys(queryAtual).sort();
      const chavesNovas = Object.keys(query).sort();

      let saoIguais = chavesAtuais.length === chavesNovas.length;
      if (saoIguais) {
        for (let i = 0; i < chavesAtuais.length; i++) {
          const k = chavesAtuais[i];
          if (String(queryAtual[k]) !== String(query[k])) {
            saoIguais = false;
            break;
          }
        }
      }

      if (!saoIguais) {
        this.$router.replace({ path: this.$route.path, query: query }).catch(function (err) {
          if (err && err.name !== 'NavigationDuplicated') {
            console.error('Erro ao sincronizar URL:', err);
          }
        });
      }
    },
    filtroCorrespondeAQuery(query) {
      const qEsperada = this.gerarQueryDeFiltro(this.pagina, this.itensPorPagina, this.filtro);
      const kEsperadas = Object.keys(qEsperada).sort();
      const kRecebidas = Object.keys(query || {}).sort();
      if (kEsperadas.length !== kRecebidas.length) return false;
      for (let i = 0; i < kEsperadas.length; i++) {
        const k = kEsperadas[i];
        if (String(qEsperada[k]) !== String(query[k])) return false;
      }
      return true;
    },
    async deletar(conta) {
      this.buttonDisabled = await true;
      try {
        await this.$http.put(`conta/` + conta.id, {id_status: 5});
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "excluir",
          setor: "financeiro",
          ip: window.localStorage.getItem("ip"),
          texto: "Exclusão da Conta a Receber N°" + conta.id
        };
        await this.$logger(logData);
        await this.getContasReceber();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        this.buttonDisabled = await false;
      }
    },
    async quitacaoDelet(conta) {
      if (this.$atividades.permissoes.includes(25)) {
        this.buttonDisabled = await true;
        try {
          await this.$http.put(`conta/` + conta.id, {
            id_status: 1,
            data_pagamento: null
          });
          await this.$http.delete(`desquitar/` + conta.id);
          let logData = {
            id_colaborador: localStorage.getItem("id"),
            funcao: "excluir",
            setor: "financeiro",
            ip: window.localStorage.getItem("ip"),
            texto: "Exclusão da Quitação da Conta a Pagar N°" + conta.id
          };
          await this.$logger(logData);
          await this.getContasReceber();
        } catch (err) {
          const error = this.$httpErrors(err);
          this.$vs.notify(error);
          if (error.code == 401) {
            await window.localStorage.clear();
            await this.$router.push("/");
          }
          ;
        } finally {
          this.buttonDisabled = await false;
        }
      } else {
        this.$vs.notify({
          title: "Não autorizado",
          text: "Você não tem autorização para realizar esta ação",
          color: "danger"
        })
      }

    },
    async contrato(id_contrato) {
      this.$router.push("/contrato?id=" + id_contrato);
    },
    async renderComponent(component2Render, item) {
      this.buttonComponent = component2Render;
      this.selectedItem = item;
      this.reRenderButtonComponent++;
    },
    async confirmarDesnegativacao(item) {
      this.selectedItem = item;
      this.modalEnviarVia = await false;
      await this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: `Deseja desnegativar esta conta?`,
        acceptText: "Confirmar",
        cancelText: "Cancelar",
        text: `Motivo: ${item.motivo}`,
        accept: await this.desnegativar
      });
    },
    async desnegativar() {
      this.buttonDisabled = await true;
      try {
        await this.$http.put("conta/" + this.selectedItem.id, {
          negativado: 0,
          motivo: ""
        });
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "update",
          setor: "financeiro",
          ip: window.localStorage.getItem("ip"),
          texto: "Desnegativação da conta N° " + this.selectedItem.id
        };
        await this.$logger(logData);
        await this.getContasReceber();
      } catch (err) {
        const error = this.$httpErrors(err);
        await this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        this.buttonDisabled = await false;
      }
    },

    async getFornecedores() {
      this.$vs.loading()
      try {
        this.fornecedores = await this.$http.get(`fornecedor`)
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        this.$vs.loading.close()
      }
    }
  },
  async mounted() {
    this.inicializarFiltrosDaUrl();
    await this.getContasReceber();
    this.sincronizarUrl();
    this.getFornecedores();
  },
  beforeDestroy() {
    if (this.searchCancelSource) {
      this.searchCancelSource.cancel('Componente destruído');
    }
    if (this.exportAbortController) {
      this.exportAbortController.abort();
    }
    try {
      this.$vs.loading.close("#tabelaContasReceber > .con-vs-loading");
      this.$vs.loading.close();
    } catch (e) {}
  },
  watch: {
    '$route.query': {
      handler() {
        const query = this.$route.query || {};
        if (this.filtroCorrespondeAQuery(query)) {
          return;
        }
        this.inicializarFiltrosDaUrl();
        this.getContasReceber();
      }
    }
  },
  components: {
    Filtro,
    ...components,
    Cadastrar,
    Editar,
    Quitar,
    VisualizarCliente,
    pagamentoParcial,
    Negativar,
    ModalCadastroFornecedor
  }
};
</script>
<style lang="scss">
.popper-itens-paginacao {
  z-index: 99999 !important;
}

.empty-contas-container {
  min-height: calc(100vh - 200px);
}

.empty-icon-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(var(--vs-primary), 0.1);
}

.scroll-contas-receber {
  height: 82vh !important;
}

.contas-tabela {
  th, td {
    padding: 0.35rem 0.5rem !important;
    vertical-align: middle !important;
  }
}

.barra-rodape-escuro {
  .vx-card__collapsible-content .vx-card__body {
    padding: 0.4rem 0.75rem !important;
  }
}

.rodape-flex-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  gap: 8px 14px;
}

.rodape-col-voltar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.rodape-col-valores {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-grow: 1;
  min-width: 0;
  gap: 6px 14px;
  padding: 0 4px;

  .total-pill {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    color: #ffffff;
    font-size: 12px;
    line-height: 1.2;

    .total-label {
      color: rgba(255, 255, 255, 0.72);
      font-size: 12px;
      margin-right: 4px;
    }

    .total-val {
      color: #ffffff;
      font-size: 13px;
      font-weight: 600;
    }
  }
}

.rodape-col-acoes {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  gap: 8px;
  flex-wrap: nowrap;

  > div {
    width: auto !important;
    display: inline-flex !important;
    flex-shrink: 0 !important;
  }

  .mr-6 {
    margin-right: 0 !important;
  }

  button, .vs-button {
    float: none !important;
    margin-right: 0 !important;
    white-space: nowrap !important;
  }
}

.cardTable {
  transition-duration: 300ms;
  border-style: solid;
  border-radius: 4px;
  border-color: rgba(211, 211, 211, 0.493);
  border-width: 2px;

  &:hover {
    transition-duration: 555ms;
    transform: translateY(-3px);
    box-shadow: 0px 4px 25px 0px rgba(226, 226, 226, 0.25);
  }
}

thead tr th#center {
  .vs-table-text {
    justify-content: center !important;
  }
}

.el-popconfirm__main {
  font-size: 12px !important;
}

.table_height {
  height: 72vh !important;
}

.nome-cliente-small {
  font-weight: 600;
  font-size: 10px;
}

@keyframes spinSlow {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.rotacionar-spinner {
  animation: spinSlow 1.4s linear infinite;
  display: inline-block;
}

.modal-exportacao-excel .vs-popup {
  width: 480px !important;
  max-width: 95vw !important;
  border-radius: 12px !important;
}

/* ═══ Skeleton Loading Shimmer ═══ */
.skeleton-shimmer {
  background: linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 50%, #f1f5f9 100%);
  background-size: 200% 100%;
  animation: skeletonShimmerAnimation 1.5s infinite linear;
  border-radius: 4px;
}

.skeleton-shimmer-dark {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.28) 50%, rgba(255, 255, 255, 0.12) 100%);
  background-size: 200% 100%;
  animation: skeletonShimmerAnimation 1.5s infinite linear;
  border-radius: 4px;
}

@keyframes skeletonShimmerAnimation {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.skeleton-tr {
  td {
    padding: 0.6rem 0.5rem !important;
    vertical-align: middle !important;
    border-bottom: 1px solid #f1f5f9 !important;
  }
}

/* ═══ Loading Centralizado da Tabela ═══ */
#tabelaContasReceber {
  position: relative !important;
}

.overlay-loading-tabela {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.15);
  z-index: 50;
  pointer-events: all;
}

.loading-box-central {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #ffffff;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(61, 164, 253, 0.25);
  transform: translateY(-20px);
}

.spinner-moderno {
  width: 32px;
  height: 32px;
  border: 3px solid rgba(61, 164, 253, 0.2);
  border-top-color: #3da4fd;
  border-radius: 50%;
  animation: spinSlow 0.8s linear infinite;
  flex-shrink: 0;
}

.loading-info-central {
  display: flex;
  flex-direction: column;
}

.loading-titulo-central {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.2;
}

.loading-subtitulo-central {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}

.fade-loading-enter-active,
.fade-loading-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.fade-loading-enter,
.fade-loading-leave-to {
  opacity: 0;
  transform: scale(0.96);
}
</style>